import { FC } from 'react';
// Types
import MediaTypes from 'types/MediaTypes';
import MidRollPositions from 'types/MidRollPositions';
import Paths from 'types/Paths';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// i18next
import { useTranslation } from 'react-i18next';

const WaiverPage:FC = () => {
  const { t } = useTranslation('common');
  const navigateTo = useNavigateTo();
  // State
  const quiz:any = useAppSelector(selectQuiz);

  const handleYesClick = () => {
    let path:Paths = 'countdown';
    let params = {};
    if ( quiz.brandVideo ){
      path = 'media';
      params = { mediaType: MediaTypes.BrandVideo };
    } else {
      if ( quiz.advertVideo.videoUrl && quiz.advertVideo.startQuiz ){
        path = 'media';
        params = {
          mediaType: MediaTypes.MidRollVideo,
          midRollPosition: MidRollPositions.Start
        };
      }
    }
    navigateTo(path, params);
  }

  const handleNoClick = () => {
    navigateTo('start');
  }

  return (
    <div
      className="min-h-screen flex items-center p-4"
      style={{
        backgroundImage: `linear-gradient(45deg, ${quiz.primaryColor} 0%, ${quiz.secondaryColor} 65%, ${quiz.tertiaryColor} 100%)`
      }}
    >
      <div className="
        w-full
        flex flex-col items-center
        bg-gray-200 rounded-lg
        p-4
      ">
        {quiz.showBrandLogoOnWaiver ? (
          <div className="mb-4">
            <img className="h-14" src={quiz.logoImage} alt="QuizWizard" />
          </div>
        ) : null}
        <p className="text-center mb-4">{quiz.waiverText}</p>
        <div className="flex gap-4">
          <Button onClick={handleYesClick}>{t('common.yes')}</Button>
          <Button onClick={handleNoClick}>{t('common.no')}</Button>
        </div>
      </div>
    </div>
  )
}

export default WaiverPage;
